export const API_URL = process.env.REACT_APP_API_URL as string;
export const JWT_SECRET = process.env.JWT_SECRET as string;
export const VIMEO_TOKEN = process.env.REACT_APP_VIMEO_TOKEN as string;
